import React from 'react';
import { Grid, List } from 'semantic-ui-react';

import FieldValues from 'components/FieldValues';
import WizardEventSummarySection from 'components/WizardEventSummarySection';
import SummaryApplicationApplicatorListItem from './components/SummaryApplicationApplicatorListItem';
import SummaryApplicationJustification from './components/SummaryApplicationJustification';
import SummaryApplicationTechnicalPersonName from './components/SummaryApplicationTechnicalPersonName';
import { FERTILIZER_EVENT_WIZARD_APPLICATION_STEP } from '../../../../constants';
import SummaryApplicationMethodListItem from './components/SummaryApplicationMethodListItem';
import SummaryApplicationSupplierListItem from './components/SummaryApplicationSupplierListItem';
import SummaryApplicationComment from './components/SummaryApplicationComment';

interface Props {
    readOnly: boolean;
}

export default function FertilizerEventSummaryApplication({
    readOnly
}: Props): React.ReactElement {
    return (
        <WizardEventSummarySection
            title="Application"
            sprayEventWizardStep={FERTILIZER_EVENT_WIZARD_APPLICATION_STEP}
            readOnly={readOnly}
        >
            <List>
                <Grid>
                    <FieldValues
                        fieldNames={[
                            'operatorPersonId',
                            'technicalPersonName',
                            'supplier',
                            'applicationMethod',
                            'justification',
                            'comment'
                        ]}
                    >
                        {({
                            operatorPersonId,
                            technicalPersonName,
                            supplier,
                            applicationMethod,
                            justification,
                            comment
                        }): React.ReactElement => (
                            <React.Fragment>
                                <Grid.Row>
                                    <Grid.Column
                                        mobile={8}
                                        tablet={4}
                                        computer={4}
                                    >
                                        <SummaryApplicationApplicatorListItem
                                            operatorPersonId={operatorPersonId}
                                        />
                                    </Grid.Column>
                                    <Grid.Column
                                        mobile={8}
                                        tablet={4}
                                        computer={4}
                                    >
                                        <SummaryApplicationTechnicalPersonName
                                            technicalPersonName={
                                                technicalPersonName
                                            }
                                        />
                                    </Grid.Column>
                                    <Grid.Column
                                        mobile={8}
                                        tablet={4}
                                        computer={4}
                                    >
                                        <SummaryApplicationSupplierListItem
                                            supplier={supplier}
                                        />
                                    </Grid.Column>
                                    <Grid.Column
                                        mobile={8}
                                        tablet={4}
                                        computer={4}
                                    >
                                        <SummaryApplicationMethodListItem
                                            applicationMethod={
                                                applicationMethod
                                            }
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column
                                        mobile={8}
                                        tablet={4}
                                        computer={4}
                                    >
                                        <SummaryApplicationJustification
                                            justification={justification}
                                        />
                                    </Grid.Column>
                                    <Grid.Column
                                        mobile={8}
                                        tablet={12}
                                        computer={12}
                                    >
                                        <SummaryApplicationComment
                                            comment={comment}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </React.Fragment>
                        )}
                    </FieldValues>
                </Grid>
            </List>
        </WizardEventSummarySection>
    );
}
